module.exports = __webpack_public_path__ + "img/GAME_FLAG1.19181833.jpg";